var map = {
	"./2023-09-12.json": "Sd/4"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IE+d";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/q&a \.json$
// module id = IE+d
// module chunks = 3